import { List, Map, fromJS } from 'immutable';
import { finish as updateCustomer } from './update';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let realityCheck = state.get('reality-check') || Map();
    let user = realityCheck.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', void 0);

    return state.set(
        'reality-check', realityCheck.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let realityCheck = state.get('reality-check') || Map();
    let user = realityCheck.get(id) || Map();

    user = user
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set(
        'reality-check', realityCheck.set(id, user)
    );
}

export function finish(state, { id, customer }) {
    id = parseInt(id, 10);

    let realityCheckEl = state.get('reality-check') || Map();
    let userEl = realityCheckEl.get(id) || Map();

    userEl = userEl
            .set('state', 'FINISHED')
            .set('errors', void 0);

    state = state.set('reality-check', realityCheckEl.set(id, userEl));

    return customer ? updateCustomer(state, { id, customer }) : state;
}

export function clear(state) {
    return state.set('reality-check', Map());
}
